import React from "react";
import { MapPin, Mail, Clock } from "lucide-react";
import { BRAND, ACTIVE_LOCATIONS, HOURS_SCHEDULE } from "../../lib/constants";

export const DispensaryInfo = () => {
  return (
    <section id="dispensary-info" className="py-24 sm:py-32 bg-white" data-testid="dispensary-info">
      <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-12 gap-10">
        <div className="lg:col-span-5">
          <div className="text-[10px] uppercase tracking-[0.3em] text-brand mb-5">Come Visit</div>
          <h2 className="font-serif text-5xl sm:text-6xl leading-[0.95] tracking-tight">
            Find your <em className="text-brand">nearest</em> DWC.
          </h2>

          <div className="mt-10 space-y-6">
            {ACTIVE_LOCATIONS.map((loc) => (
              <div key={loc.id} className="border-l-2 border-brand pl-5" data-testid={`info-loc-${loc.id}`}>
                <div className="text-[10px] uppercase tracking-[0.3em] text-ink-muted mb-1">{loc.label}</div>
                <div className="font-serif text-xl">{loc.street}, {loc.city}</div>
                {loc.phone && (
                  <a href={loc.phoneHref} className="mt-2 inline-block text-base text-ink hover:text-brand" data-testid={`info-phone-${loc.id}`}>
                    ☎ {loc.phone}
                  </a>
                )}
              </div>
            ))}
          </div>

          <div className="mt-10 pt-8 border-t border-black/10">
            <div className="text-[10px] uppercase tracking-[0.3em] text-brand mb-4 flex items-center gap-2">
              <Clock size={12} /> Business Hours
            </div>
            <ul className="divide-y divide-black/10 border-y border-black/10" data-testid="hours-schedule">
              {HOURS_SCHEDULE.map((d) => (
                <li key={d.day} className={`flex items-center justify-between py-2.5 text-base ${d.closed ? "text-ink-muted" : ""}`} data-testid={`hours-${d.day.toLowerCase()}`}>
                  <span className="font-medium">{d.day}</span>
                  <span className={d.closed ? "text-brand uppercase tracking-[0.15em] text-[12px]" : ""}>{d.hours}</span>
                </li>
              ))}
            </ul>
            <a href={`mailto:${BRAND.email}`} className="mt-6 inline-flex items-center gap-2 text-ink hover:text-brand">
              <Mail size={16} className="text-brand" /> {BRAND.email}
            </a>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="border border-black/10 overflow-hidden h-full min-h-[500px] relative">
            <iframe
              title="DWC map — Uptown"
              src={`https://www.google.com/maps?q=${encodeURIComponent(ACTIVE_LOCATIONS[0].mapQuery)}&output=embed`}
              className="w-full h-full absolute inset-0"
              style={{ border: 0, minHeight: 500 }}
              loading="lazy"
              data-testid="google-map-embed"
            />
          </div>
          <div className="mt-4 flex items-center justify-between text-[11px] uppercase tracking-[0.2em] text-ink-muted">
            <div className="inline-flex items-center gap-2"><MapPin size={12} className="text-brand" /> Showing: DWC Uptown · 4915 Georgia Ave NW</div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DispensaryInfo;
